import { type Operator } from 'types/operator.types';
import { type ICreateOperatorPayload } from 'types/payloads/operator.payload.types';
import BaseAPI from './base.api';

export interface SyncCredentialsResult {
  deviceId: string;
  messageId: string;
}

export interface SyncCredentialsResponse {
  customerId: string;
  synced: boolean;
  operatorsCount: number;
  devicesCount: number;
  results: SyncCredentialsResult[];
}

export default class OperatorAPI extends BaseAPI {
  create = async (payload: ICreateOperatorPayload) => {
    const response = await this.API.post('operator', payload);
    return response.data;
  };

  update = async (operatorId: string, payload: ICreateOperatorPayload) => {
    const response = await this.API.patch(`operator/${operatorId}`, payload);
    return response.data;
  };

  /**
   * Gets all operators the current user has access to
   * @returns A list of operators
   */
  getAll = async (): Promise<Operator[]> => {
    const response = await this.API.get('operator');
    return response.data;
  };

  /**
   * Activate Operator the specified operator
   * @returns A success message
   */
  activationOperator = async (operatorId: string, isActive: boolean) => {
    const response = await this.API.patch(
      `operator/${operatorId}/activationOperator`,
      { isActive }
    );
    return response.data;
  };

  /**
   * Pushes the current operator credentials (id, name, role, pin) to
   * tablet devices via SQS. Omit `deviceId` to sync every device for the
   * customer; pass it to sync only that one device.
   */
  syncCredentials = async (
    deviceId?: string
  ): Promise<SyncCredentialsResponse> => {
    const response = await this.API.get('operator/sync-credentials', {
      params: {
        customerId: this.customerId,
        ...(deviceId && { deviceId }),
      },
    });
    return response.data;
  };

  /**
   * Switches the operator session to the selected asset
   * @returns A success message
   */
  sessionSwitch = async (bumperNumber: string, operatorId: string) => {
    const response = await this.API.post('operator/session-switch', {
      customerId: this.customerId,
      bumperNumber,
      operatorId,
    });
    return response.data;
  };
}
